export default {
  StronglyHeterogenous: '70% - 130%',
  IncreasinglyHeterogenous: '75% - 125%',
  Heterogenous: '80% - 120%',
  SlightlyHeterogeneous: '85% - 115%',
  Homogeneous: '90% - 110%'
}
